import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles(() => ({
  root: {
    display: "grid",
    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
    gridGap: "1.5rem",
    justifyItems: "center",
    gridTemplateAreas: `
    '. . .'
    '. image .'
    'text text text'
    'button button button '
    'browserLinks browserLinks browserLinks'
    `,
  },
  arrowRight: {
    width: "5rem",
    height: "6rem",
    gridArea: "arrow",
    placeSelf: "end",
    marginTop: ".2rem",
  },
  text: {
    gridArea: "text",
    maxWidth: "20rem",
  },
  mainImage: {
    gridArea: "image",
  },
  button: {
    gridArea: "button",
  },
  browserLinks: {
    gridArea: "browserLinks",
  },
}));
